import React from 'react';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'
import { useClearCacheCtx } from 'react-clear-cache'

import Home from 'pages/Home';
//import PagarTarjeta from 'pages/Credito/3-PagarTarjeta/pagar';
import PagarTarjetaOld from 'pages/Credito/PagarPlanes';
import MiTarjeta from 'pages/Credito/4-MiTarjeta';
import VerCVV from 'pages/Credito/4-MiTarjeta/verCvv';
import PagarEnTienda from 'pages/Credito/3-PagarTarjeta/pagarEnTienda';
import GenerarCodigo from 'pages/Credito/3-PagarTarjeta/generarCodigo';
// import Beneficios from 'pages/Beneficios';
// import AgregadaCorrectamente from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria/AddSuccess';
import PagarTarjetaPaso2 from 'pages/Credito/3-PagarTarjeta/pagar/paso2';
import PagarTarjetaPaso3 from 'pages/Credito/3-PagarTarjeta/pagar/paso3';
import PagoExpress from 'pages/Credito/3-PagarTarjeta/pagoExpress';
import PagoReferenciado from 'pages/Credito/3-PagarTarjeta/PagoReferenciado'
//import ElegirTarjeta from 'pages/Credito/3-PagarTarjeta/pagar/paso4';
import { ElegirTarjeta } from 'pages/Credito/3-PagarTarjeta/ElegirTarjeta';
import ThankYouPage from 'pages/Credito/3-PagarTarjeta/pagar/thakyouPage';
import AgregarTarjetaBancaria from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria';
// import DireccionTarjetaBancaria from 'pages/Credito/2-AgregarTarjeta/AgregarTarjetaBancaria/DirectionCard';
// import SolicitarEstadoCuenta from 'pages/Credito/5-EstadoCuenta/solicitarEstado';
// import Movimientos from 'pages/Credito/6-Movimientos/movimientos';
import InformacionTarjetaExpress from 'pages/Credito/3-PagarTarjeta/pagoExpress/informacionTarjetaExpress';
import SolicitarTarjetaOld from 'pages/Credito/10-SolicitarTarjeta';
// import Beneficios from 'pages/Beneficios/beneficiosNew';
// import BeneficiosNew from 'pages/Beneficios/beneficiosNew';
// import LandingBeneficiosOld from 'pages/Beneficios/beneficiosDesktop/landingBeneficios';
// import LandingBeneficios from 'pages/Beneficios/landing';
// import preBeneficios from 'pages/Beneficios/preBeneficios';


import Authenticated from 'pages/LoginRegistro/Authenticated';
import AgregarTarjeta from 'pages/Credito/2-AgregarTarjeta';
import ConsultarSaldo from 'pages/Credito/1-Consulta';


import SolicitudExitosa from 'pages/Credito/5-EstadoCuenta/solicitudExitosa';
import SolicitarPermisos from 'pages/Credito/5-EstadoCuenta/solicitarPermisos';
import ConsultarEstatusSolicitudOld from 'pages/Credito/9-ConsultarEstatusSolicitud/consultarEstatus';

import {Cumpleanios} from 'pages/Landings/Cumpleanios';
import {CuponVip} from 'pages/Landings/CuponVip';
import {DescuentoCompra} from 'pages/Landings/PrimeraCompra';

import Login from 'pages/LoginRegistro/Login';

import Error404 from 'pages/Error/Error404';

import { Router, Route, Redirect, Switch } from "react-router-dom";
import PrivateRoute from 'routers/privateRouter';
import BrowserHistory from 'routers/history';
import SolicitarTarjeta from 'pages/Credito/SolicitarTarjeta';

/* --------------------------------  */
// import newAuth from 'newPages/Auth';
import PreHome from 'newPages/PreHome';
import HomeNew from 'newPages/Home';
import BeneficiosNew from 'newPages/Beneficios';
import LandingBeneficiosNew from 'newPages/Beneficios/landing';
import PreBeneficiosNew from 'newPages/Beneficios/preBeneficios';
import AgregarTarjetaNew from 'newPages/AgregarTarjeta/TarjetaDepartamental';
import MovimientosNew from 'newPages/Movimientos';
import EstadoCuentaNew from 'newPages/EstadosDeCuenta';
import PagoExpressNew from 'newPages/Pagos/PagoExpress';
import ResumenTarjetaExpressNew from 'newPages/Pagos/PagoExpress/Resumen';

import PagarTarjetaNew from 'newPages/Pagos/PagarPlanes';
import AgregarTarjetaBancariaNew from 'newPages/AgregarTarjeta/TarjetaBancaria';
import ConsultarEstatusSolicitudNew from 'newPages/ConsultarSolicitud/consultarEstatus';
import ElegirTarjetaNew from 'newPages/Pagos/ElegirTarjeta';
import ThankYouPageNew from 'newPages/Pagos/FlujoDePago/ThakyouPage/index';

// import SetAuth from 'newPages/SetAuth';



BrowserHistory.listen(location => {
  //console.log('Set page to', location.pathname);
  // eslint-disable-next-line no-undef
  //ineum('page', location.pathname);
  // Note that the above can result in many useless pages when you are making use of path parameters.
  // In these cases you will have to define the page via different means, e.g. by creating a custom
  // Route component which accepts a 'pageName' property.
});

function App() {
  const { isLatestVersion, emptyCacheStorage } = useClearCacheCtx();
  
  return (
    <>
      <Router history={BrowserHistory}>
        <Switch>
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}`} exact component={PreHome} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta`} exact component={AgregarTarjetaNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`} exact component={HomeNew} />


          <Route exact path={`${BASE_PATH}`} >
            <Redirect to={`${BASE_PATH}${SUB_DIRECTORY}`} />
          </Route>
          <Route exact path={`${BASE_PATH}Credito-Sears`} >
            <Redirect to={`${BASE_PATH}${SUB_DIRECTORY}`} />
          </Route>
          <PrivateRoute exact path={`${BASE_PATH}${SUB_DIRECTORY}`} >
            <Redirect to={`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`} />
          </PrivateRoute>

                    
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}beneficios`} exact component={BeneficiosNew} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}beneficios/landing`} exact component={LandingBeneficiosNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}home`} exact component={PreBeneficiosNew}/>

          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}movimientos-tarjeta`} exact component={MovimientosNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}solicitar-estado-cuenta`} exact component={EstadoCuentaNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pago-express`} exact component={PagoExpressNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}informacion-tarjeta-express`} exact component={ResumenTarjetaExpressNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}consultar-estatus-solicitud`} exact component={ConsultarEstatusSolicitudNew} />

          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta-bancaria`} exact component={AgregarTarjetaBancariaNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`} exact component={PagarTarjetaNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}elegir-tarjeta`} exact component={ElegirTarjetaNew} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}thakYouPage`} exact component={ThankYouPageNew} />

          {/* <Route path={`${BASE_PATH}SetAuth`} component={SetAuth} /> */}


          <Route path={`${BASE_PATH}${SUB_DIRECTORY}carta-cumpleanos`} exact component={Cumpleanios} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}descuento-primera-compra`} exact component={DescuentoCompra} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}cupon-vip`} exact component={CuponVip} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}preguntas-frecuentes`} exact component={LandingBeneficiosNew} />


          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta-old`} exact component={AgregarTarjeta} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}permisos-estado-cuenta`} exact component={SolicitarPermisos} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}solicitud-exitosa`} exact component={SolicitudExitosa} />
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`} exact component={ConsultarSaldo} /> */}
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo-old`} exact component={ConsultarSaldo} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}mi-tarjeta`} exact><Redirect to={`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`} /></PrivateRoute> 


          <Route path={`${BASE_PATH}authenticated`} component={Authenticated} />
          <Route path={`${BASE_PATH}login`} component={Login} />

          <Route path={`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-sears`} exact component={SolicitarTarjeta}/>
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}consultar-estatus-solicitud`} exact component={ConsultarEstatusSolicitudOld} />




          {/* <Route path={`${BASE_PATH}${SUB_DIRECTORY}oldHome`} exact component={Home} />  */}
          {/* <Route path={`${BASE_PATH}${SUB_DIRECTORY}landing-beneficios`} exact component={LandingBeneficiosNew} /> */}
          {/* <Route path={`${BASE_PATH}${SUB_DIRECTORY}beneficios-old`} exact component={Beneficios} /> */}
          {/* <Route path={`${BASE_PATH}${SUB_DIRECTORY}landing-beneficios-old`} exact component={LandingBeneficiosOld} /> */}

          {/* <Route path={`${BASE_PATH}${SUB_DIRECTORY}agregada-correctamente`} exact component={AgregadaCorrectamente} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}movimientos-tarjeta`} exact component={Movimientos} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}tarjetas-sears`} exact component={Movimientos} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}solicitar-estado-cuenta`} exact component={SolicitarEstadoCuenta} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}consultar-saldo`} exact component={ConsultarSaldo} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}mi-tarjeta`} exact component={MiTarjeta} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}ver-cvv`} exact component={VerCVV} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}referenciado`} exact component={PagoReferenciado} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pago-express`} exact component={PagoExpress} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}informacion-tarjeta-express`} exact component={InformacionTarjetaExpress} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta-bancaria`} exact component={AgregarTarjetaBancaria} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`} exact component={PagarTarjeta} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}elegir-tarjeta`} exact component={ElegirTarjeta} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}thakYouPage`} exact component={ThankYouPage} /> */}
          {/* <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}pagar-en-tienda`} exact component={PagarEnTienda} />
          <PrivateRoute path={`${BASE_PATH}${SUB_DIRECTORY}generar-codigo`} exact component={GenerarCodigo} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta-paso2`} exact component={PagarTarjetaPaso2} />
          <Route path={`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta-paso3`} exact component={PagarTarjetaPaso3} /> */}
          

          <Route path={`${BASE_PATH}:anything*`} component={Error404} />
        </Switch>
      </Router>
    </>
  );
}

export default App;